<template>
  <form @submit="sendForm" class="form-init">
    <h1 class="title">
      <span class="title-one">¡HOLA!</span>
      <span class="title-two"> Para empezar, contanos un poco sobre vos: </span>
    </h1>
    <div id="step-one">
      <section class="container-fluid">
        <div class="columns is-multiline is-mobile">
          <div class="column">
            <ul class="lista mt-5">
              <li class="subtitle">Nombre completo</li>
              <li>
                <InputUl
                  :inpType="'text'"
                  @input="updateName"
                  :inpValue="formData.init.name"
                  :inpName="'pName'"
                  :required="'required'"
                />
              </li>
              <li>
                <InputUl
                  @input="updateLastName"
                  :inpType="'text'"
                  :inpName="'pLastname'"
                  :placeholder="'Ingresar apellido'"
                  :inpTab="'1'"
                  :required="'required'"
                />
              </li>
            </ul>
            <ul class="lista mt-5">
              <li class="subtitle">Numero de DNI</li>
              <li>
                <InputUl
                  @input="updateDni"
                  :placeholder="'Ingresar DNI'"
                  :inpType="'number'"
                  :inpName="'pDni'"
                  :required="'required'"
                />
              </li>
            </ul>
            <ul class="lista mt-5">
              <li class="subtitle">Edad</li>
              <li>
                <InputUl
                  @input="updateAge"
                  :inpName="'pAge'"
                  :inpType="'number'"
                  :inpValue="formData.init.age"
                  :required="'required'"
                />
              </li>
            </ul>
          </div>
        </div>
      </section>
      <button class="button" @click="showStepthree">Continuar</button>
      <ShowError
        :title="showError.title"
        :msg="showError.msg"
        :delete="showError.delete"
        :isActive="showError.isActive"
      />
    </div>
    <div id="step-three">
      <section class="container-fluid">
        <div class="columns is-multiline is-mobile">
          <div class="column">
            <ul class="lista">
              <li class="subtitle">Teléfono</li>
              <li>
                <InputUl
                  @input="updateCodeArea"
                  :inpName="'pCodeArea'"
                  :inpType="'number'"
                  :placeholder="'Ej. 11'"
                  :disabled="false"
                />
              </li>
              <li>
                <InputUl
                  @input="updateTelephone"
                  :inpName="'pTelephone'"
                  :inpType="'number'"
                  :placeholder="'Ej. 4545 4545'"
                  :disabled="false"
                />
              </li>
            </ul>
            <ul class="lista mt-5">
              <li class="subtitle">Correo electrónico</li>
              <li>
                <InputUl
                  @input="updateEmail"
                  :inpType="'email'"
                  :inpValue="formData.init.email"
                  :inpName="'pEmail'"
                  :placeholder="'Ingresar email'"
                  :disabled="false"
                />
              </li>
            </ul>
            <ul class="lista mt-5 mb-5">
              <li class="subtitle">¿Comó te contactamos?</li>
              <li>
                <div class="select">
                  <select
                    v-model="formData.contact"
                    width="100px"
                    :name="'selectOption'"
                  >
                    <option disabled value="">Seleccionar</option>
                    <option value="opc-whatsapp">Por Whatsapp</option>
                    <option value="opc-telephone">Por Teléfono</option>
                    <option value="opc-email">Por correo electrónico</option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <button class="button" type="submit">Finalizar</button>
      <ShowError
        :title="showError.title"
        :msg="showError.msg"
        :delete="showError.delete"
        :isActive="showError.isActive"
      />
    </div>
  </form>
</template>

<script>
import axios from "axios";
import InputUl from "./../form/InputUl";
import ShowError from "./../form/ShowError";

export default {
  name: "FormContratar",
  components: {
    InputUl,
    ShowError,
  },
  props: ["data"],
  data() {
    return {
      showError: {
        title: "",
        msg: "",
        delete: true,
        isActive: false,
      },
      steps: {
        one: true,
        two: false,
        three: false,
      },
      formData: {
        contact_id: this.$store.getters.getPersonForm.leadID,
        init: this.$store.getters.getPersonForm.person,
        sons: this.data.personData.sons,
        job: this.data.personData.job,
        partner: this.data.personData.partner,
        personPrice: this.data.personData.personPrice,
        planType: this.data.planType,
        firstPrice: this.data.firstPrice,
        countSons: 0,
        lastname: "",
        dni: 0,
        codeArea: 0,
        telephone: 0,
        contact: "",
      },
    };
  },
  methods: {
    sendForm(e) {
      e.preventDefault();
      this.showError.isActive = false;
      let isCodeArea = false,
        isTelephone = false,
        isEmail = false,
        isMethodContact = false;

      if (this.formData.codeArea == 0) {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo código de área";
        this.showError.isActive = true;
        return false;
      } else {
        isCodeArea = true;
      }

      if (this.formData.telephone == 0) {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo teléfono";
        this.showError.isActive = true;
        return false;
      } else {
        isTelephone = true;
      }

      if (this.formData.init.email == "") {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo email";
        this.showError.isActive = true;
        return false;
      } else {
        isEmail = true;
      }

      if (this.formData.contact == "") {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo de método de contacto";
        this.showError.isActive = true;
        return false;
      } else {
        isMethodContact = true;
      }

      if (isCodeArea && isTelephone && isEmail && isMethodContact) {
        let payloadPersonData = {};
        payloadPersonData.contact_id = this.formData.contact_id;
        // payloadPersonData.sons = this.formData.sons;
        payloadPersonData.fullname =
          this.formData.init.name + " " + this.formData.lastname;

        payloadPersonData.dni = this.formData.dni;
        payloadPersonData.codeArea = this.formData.codeArea;
        payloadPersonData.telephone = this.formData.telephone;

        payloadPersonData.family = 0;

        if (this.formData.partner.age && this.formData.partner.age.age > 0)
          payloadPersonData.family = 1;
        if (this.formData.sons)
          payloadPersonData.family += parseInt(this.formData.sons);

        this.$store.commit("setPersonForm", payloadPersonData);

        const dataForm = new FormData();
        for (const [key, value] of Object.entries(
          this.$store.getters.getPersonForm
        )) {
          dataForm.append(key, value);
        }

        e.target.lastElementChild.lastElementChild.classList.add("is-loading");

        axios({
          method: "post",
          url: "https://api.osfatun.com.ar/api/sales/quote",
          // url: "https://osfatun-crm-api.herokuapp.com/api/sales/quote",
          data: dataForm,
        })
          .then(() => {
            this.$router.push({ name: "Gracias" });
          })
          .catch((err) => {
            console.log("Error to send lead \n" + err);
            this.$router.push({ name: "Gracias" });
          });
      }
    },
    showStepthree(e) {
      e.preventDefault();
      //Reset showError
      this.showError.isActive = false;
      this.showError.msg = "";

      let isLastname = false,
        isDni = false;

      if (this.formData.lastname == "") {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo Apellido";
        this.showError.isActive = true;
        return false;
      } else {
        isLastname = true;
      }

      if (this.formData.dni == 0 || this.formData.dni < 10000000) {
        this.showError.title = "Campo incompleto";
        this.showError.msg = "Falta completar el campo DNI o es icorrecto";
        this.showError.isActive = true;
        return false;
      } else {
        isDni = true;
      }

      if (isLastname && isDni) {
        document.getElementById("step-one").style.display = "none";
        document.getElementById("step-three").style.display = "block";
      }
    },
    updateLastName(value) {
      this.formData.lastname = value;
    },
    updateName(value) {
      this.formData.init.name = value;
    },
    updateDni(value) {
      this.formData.dni = value;
    },
    updateAge(value) {
      this.formData.init.age = value;
    },
    updateCodeArea(value) {
      this.formData.codeArea = value;
    },
    updateTelephone(value) {
      this.formData.telephone = value;
    },
    updateEmail(value) {
      this.formData.init.email = value;
    },
  },
};
</script>

<style scoped>
.slide1 {
  background-color: red;
}
.slide2 {
  background-color: blue;
}
.form-init {
  position: relative;
  top: -15vh;
  background: white;
  max-width: 60%;
  padding: 40px 40px;
  margin: 0 auto;
}
h1.title {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}
select {
  border-radius: 0;
  border: 0;
  color: #00738f;
  border-bottom: 3px solid #fbaf33;
}
button {
  width: 195px;
  max-width: 195px !important;
  margin-left: auto !important;
  background: #00758f;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  display: block;
  text-transform: uppercase;
}
button:hover {
  width: 195px;
  font-weight: bold;
  color: #fff;
}
.lista {
  margin: 0;
  padding: 0;
}
.lista li {
  display: inline-block;
  margin-right: 10px;
}
.lista li:last-child {
  margin-right: 0px;
}
.lista .subtitle {
  display: block;
  margin-bottom: 10px;
  /* font-weight: bold; */
  font-size: 22px;
  color: #00758f;
  line-height: 1.9rem;
}
#step-two {
  display: none;
}
#step-three {
  display: none;
}
@media screen and (max-width: 480px) {
  .form-init {
    position: relative;
    top: -30px;
    max-width: 80%;
    padding: 40px 20px;
    margin: 0 auto;
  }
  .title {
    font-size: 20px !important;
    text-align: center;
    margin-bottom: 30px;
  }
  .title br {
    display: none;
  }
  .title-one {
    display: block;
    font-size: 50px;
    margin-bottom: 20px;
  }
  .title-two {
    display: block;
    margin-bottom: 20px;
  }
  .button {
    margin: 0 auto;
    max-width: 100% !important;
    width: 100% !important;
  }
}
</style>
